import React, { useRef, useState, useEffect } from 'react';
import Heading from "../../common/Heading";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import img1 from '../../../assets/images/Accountability.jpg';
import img2 from '../../../assets/images/Farmer Centeredness.jpg';
import img3 from '../../../assets/images/Innovativeness.jpg';
import img4 from '../../../assets/images/MultiMedia Approach.jpg';
import img5 from '../../../assets/images/Productiveness.jpg';
import './Featured.css';

const itemData = [
  {
    img: img1,
    title: 'Accountability',
    author: '@FarmRadioTrust',
  },
  {
    img: img2,
    title: 'Farmer Centeredness',
    author: '@FarmRadioTrust',
  },
  {
    img: img3,
    title: 'Innovativeness',
    author: '@FarmRadioTrust',
  },
  {
    img: img4,
    title: 'MultiMedia Approach',
    author: '@FarmRadioTrust',
  },
  {
    img: img5,
    title: 'Productiveness',
    author: '@FarmRadioTrust',
  }
];

const Featured = () => {
  const progressCircle = useRef(null);
  const progressContent = useRef(null);

  // Responsive slidesPerView state
  const [slidesPerView, setSlidesPerView] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 900) {
        setSlidesPerView(1);
      } else if (window.innerWidth < 1200) {
        setSlidesPerView(2);
      } else {
        setSlidesPerView(3);
      }
    };
    handleResize(); // Set on mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onAutoplayTimeLeft = (s, time, progress) => {
    if (progressCircle.current) {
      progressCircle.current.style.setProperty('--progress', 1 - progress);
    }
    if (progressContent.current) {
      progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
    }
  };

  return (
    <>
      <section className='featured background'>
        <div className='container'>
          <Heading title='OUR VALUES' subtitle='Our priorities in how we work' />
          <section className='mt-20'>
            <Swiper
              slidesPerView={slidesPerView}
              spaceBetween={30}
              centeredSlides={false}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              navigation={false}
              modules={[Autoplay, Pagination, Navigation]}
              onAutoplayTimeLeft={onAutoplayTimeLeft}
              className="mySwiper"
            >
              {itemData.map((item) => (
                <SwiperSlide key={item.img}>
                  <div className="featured-slide-img-wrap">
                    <img
                      src={item.img}
                      alt={item.title}
                      loading="lazy"
                      className="featured-slide-img"
                    />
                    <div className="featured-slide-overlay">
                      <div className="featured-slide-title">{item.title}</div>
                      <div className="featured-slide-author">{item.author}</div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
              <div className="autoplay-progress mt-11" slot="container-end">
                <svg viewBox="0 0 48 48" ref={progressCircle}>
                  <circle cx="24" cy="24" r="20"></circle>
                </svg>
                <span ref={progressContent}></span>
              </div>
            </Swiper>
          </section>
        </div>
      </section>
    </>
  );
};

export default Featured;
